import { useCallback, useId } from 'react'
import { useLocation } from 'react-router-dom'
import { useAyuda } from './ContextoDeAyuda'
import { useCierreConEscape } from './cierreConEscape'
import { novedadesPendientes, recorridoEnCurso, tipDePantallaPendiente } from './seleccionDeTips'
import './tips.css'

/**
 * RF-1703 · La primera vez que el usuario abre una pantalla, una tarjeta corta con lo esencial. Es NO modal: no
 * bloquea clics ni atrapa el foco, va en una esquina y se cierra con su botón o con Esc. Cerrada, no vuelve.
 *
 * Uno a la vez: no sale mientras corre el recorrido guiado ni mientras hay una novedad que mostrar, y nada con
 * «Mostrar TIPs» apagado.
 */
export function TipDePantalla() {
  const ayuda = useAyuda()
  const { pathname } = useLocation()
  const idTitulo = useId()

  const tip = ayuda.mostrarTips && !recorridoEnCurso(ayuda) && novedadesPendientes(ayuda).length === 0
    ? tipDePantallaPendiente(pathname, ayuda)
    : null

  const { marcarTip } = ayuda
  const clave = tip?.clave
  const cerrar = useCallback(() => { if (clave) marcarTip(clave) }, [clave, marcarTip])
  useCierreConEscape(tip !== null, cerrar)

  if (!tip) return null

  return (
    <aside className="tip-flotante" aria-labelledby={idTitulo}>
      <div className="tip-cuerpo">
        <span className="tip-etiqueta">TIP</span>
        <strong id={idTitulo} className="tip-titulo">{tip.titulo}</strong>
        <p className="tip-texto">{tip.texto}</p>
      </div>
      <button type="button" className="enlace tip-cerrar" onClick={cerrar} aria-label={`Cerrar el TIP «${tip.titulo}»`}>
        Entendido
      </button>
    </aside>
  )
}
